import { connect } from 'react-redux'
import { goBack } from 'react-router-redux'
import AreaCreate from '../../components/areas/area-create'
import { createServicingForWorkOrder } from '../../actions/servicings'
import { searchAvailableAreasByWorkOrder } from '../../actions/areas'
import moment from 'moment'

import at from 'lodash/at'
import get from 'lodash/get'
import debounce from 'lodash/debounce'

const mapStateToProps = (state, props) => {
  const workOrder = state.workOrders[props.params.workOrderId]
  if (!workOrder) return { location: {}, workOrder: {} }

  const location = state.locations[workOrder.location]
  let areasWithIssuesText = ''

  if (state.form.hasOwnProperty('addArea')) {
    const areaIds = get(state, 'form.addArea.areaIds.value', [])
    const selectedAreas = at(state.areas, areaIds)
    const areasWithIssues = selectedAreas.filter((area) => area.issueCount > 0)

    areasWithIssuesText = areasWithIssues.map(
      (area) => `${area.name} (${area.issueCount})`
    ).join(', ')
  }

  return {
    location,
    workOrder,
    areasWithIssuesText
  }
}

function mapDispatchToProps (dispatch, props) {
  const id = props.params.workOrderId

  dispatch(searchAvailableAreasByWorkOrder(id, '', false))

  const debouncedCreateServicings = debounce(
    (dispatch, data, comment) => {
      const promises = (data.areaIds || []).map(areaId =>
        dispatch(createServicingForWorkOrder(
          id,
          {
            ...data,
            areaId,
            ...(comment && { comment: { body: comment, timezone: moment.tz.guess() } })
          }
        ))
      )

      Promise.all(promises).then(() => dispatch(goBack()))
    },
    1000
  )

  return {
    onSubmit ({comment, ...data}) {
      // https://gist.github.com/krstffr/245fe83885b597aabaf06348220c2fe9
      debouncedCreateServicings(dispatch, data, comment)
    },

    handleClose () {
      dispatch(goBack())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AreaCreate)



// WEBPACK FOOTER //
// ./src/containers/areas/area-create-container.js